import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ComplexCases() {
  const tableData = [{
    sit: 'Tenés plata ordenada pero no sabés dónde ponerla',
    sin: 'La inflación te la come igual',
    con: '5 portafolios listos para elegir según tu perfil'
  }, {
    sit: 'Querés dolarizar pero no sabés cómo legalmente',
    sin: 'Quedás expuesto a la devaluación',
    con: 'Guía completa de Dólar MEP paso a paso'
  }, {
    sit: 'Querés invertir pero no sabés en qué confiar',
    sin: 'Parálisis por exceso de información',
    con: 'Estrategia clara por perfil y horizonte'
  }, {
    sit: 'Tenés capital pequeño y creés que no alcanza',
    sin: 'No entrás al mercado nunca',
    con: 'El Plan del 1%: empezás desde $50.000'
  }, {
    sit: 'Querés generar ingresos pasivos en dólares',
    sin: 'No sabés cómo ni desde dónde',
    con: 'Portafolio de Renta Pasiva Dólar completo'
  }];
  const kitIncludes = ['Los 5 instrumentos de inversión más accesibles para argentinos', '5 portafolios "plug and play" para cada perfil de inversor', 'Guía completa de CEDEARs', 'Dólar MEP legal paso a paso', 'Stablecoins: rendimiento del 5% al 12% anual en dólares', 'FCI para principiantes', 'Hoja de ruta primeros 12 meses', 'Diccionario del inversor', 'Tracker de portafolio', 'Los 10 errores que arruinan inversores'];
  return <section className="bg-surface py-16 px-4 border-t border-border" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <div className="text-center mb-10" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-3 font-serif" data-id="element-39">
            💎 ¿QUÉ AGREGA PORTAFOLIOS MAESTROS 2026?
          </h2>
        </div>

        <div className="overflow-x-auto mb-12 rounded-2xl border border-border shadow-md bg-white" data-id="element-40">
          <table className="w-full text-left border-collapse" data-id="element-41">
            <thead data-id="element-42">
              <tr className="bg-cream border-b border-border" data-id="element-43">
                <th className="p-5 text-ink font-bold w-1/3" data-id="element-44">Situación</th>
                <th className="p-5 font-bold w-1/3 text-urgency" data-id="element-45">
                  <div className="flex items-center" data-id="element-46">
                    <XCircle className="w-5 h-5 mr-2" data-id="element-47" /> Sin Portafolios
                  </div>
                </th>
                <th className="p-5 font-bold w-1/3 text-success" data-id="element-48">
                  <div className="flex items-center" data-id="element-49">
                    <CheckCircle2 className="w-5 h-5 mr-2" data-id="element-50" /> Con Portafolios
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-51">
              {tableData.map((row, i) => <tr key={i} className="hover:bg-surface transition-colors" data-id="element-52">
                  <td className="p-5 text-ink font-medium" data-id="element-53">{row.sit}</td>
                  <td className="p-5 text-muted" data-id="element-54">{row.sin}</td>
                  <td className="p-5 text-ink font-bold" data-id="element-55">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="bg-primary-dark rounded-3xl p-8 md:p-12 border border-gold/30 max-w-4xl mx-auto shadow-lg" data-id="element-56">
          <h3 className="text-2xl md:text-3xl font-bold text-cream mb-8 flex items-center font-serif" data-id="element-57">
            <span className="text-gold mr-4" data-id="element-58">✅</span> Portafolios Maestros 2026
            incluye:
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-59">
            {kitIncludes.map((item, i) => <li key={i} className="flex items-start text-cream/90 bg-black/20 p-3 rounded-lg border border-white/5" data-id="element-60">
                <CheckCircle2 className="w-5 h-5 text-gold mr-3 shrink-0 mt-0.5" data-id="element-61" />
                <span className="text-sm md:text-base font-medium" data-id="element-62">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}